import { Component, OnInit } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { MatSelectModule } from '@angular/material/select';
import { ReportService } from '../../features/reports/services/reports.service';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  BalanceSheetComponent,
  ProfitLossComponent,
  CashFlowStatementComponent,
  SalesByItemComponent,
  TrialBalanceComponent,
  AgingInvoiceReport,
  AgingInvoiceVendorReport,
  GeneralLedgerReport,
  AccountReport,
  JournalReport,
  VatReport,
  DayReport,
  CustomerBalanceSummaryReport,
  VendorBalanceSummary,
  MovementTrialBalanceComponent,
} from './components/reports-format.component';
import { ToastrService } from 'ngx-toastr';
import { FileExportService } from '../../shared/services/file-export.service';

import {
  AGING_REPORT_TYPES,
  PartnerTypesEnum,
} from '../../helpers/helper-file';
import { InvoiceService } from '../../features/invoice/services/invoice.service';
import { Router } from '@angular/router';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ChartOfAccountsService } from '../../features/chart-of-accounts/services/chart-of-accounts.service';
import { CustomerService } from '../../features/customers/services/customer.service';
import { VendorService } from '../../features/vendors/services/vendor.service';
import { ModuleIds } from '../../shared/permission-constants/permission-const';
import { PermissionService } from '../../shared/services/permission.service';

@Component({
  selector: 'app-reports',
  standalone: true,
  imports: [
    CommonModule,
    MatTabsModule,
    MatSelectModule,
    ProfitLossComponent,
    BalanceSheetComponent,
    MatDatepickerModule,
    MatInputModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    CashFlowStatementComponent,
    SalesByItemComponent,
    TrialBalanceComponent,
    NgxMatSelectSearchModule,
    AgingInvoiceReport,
    AgingInvoiceVendorReport,
    GeneralLedgerReport,
    AccountReport,
    JournalReport,
    VatReport,
    DayReport,
    CustomerBalanceSummaryReport,
    MovementTrialBalanceComponent,
    VendorBalanceSummary,
  ],
  templateUrl: './reports.component.html',
  styleUrl: './reports.component.scss',
})
export class ReportsComponent implements OnInit {
  loading: boolean = false;
  isExportOpen = false;
  selectedOption = 'today';
  selectedTabIndex = 0;
  accountType: any;
  isSubAccount: any;
  parentAccountId: any;
  search: string = '';
  dateRangeForm: FormGroup;
  singleDateForm: FormGroup;
  daysRangeForm: FormGroup;
  accountForm: FormGroup;
  costForm: FormGroup;
  filter: any;
  daysFilter: string = 'ALL';
  selectedCustomerId: any = null;
  selectedVendorId: any = null;
  selectedAccountId: any = -1;
  selectedProjectId: any = -1;
  startDate: any;
  endDate: any;
  chooseDate: any;
  accountId: number;
  exportFormat: string = 'csv';
  profitLossData: any = {};
  cashFlowReport: any = {};
  balanceSheetReport: any = {};
  salesByItemReport: any = {};
  salesByCustomReport: any = {};
  accountTypeSummaryReport: any = {};
  journalReport: any = {};
  generalLedgerReport: any = {};
  customerBalanceSummaryReport: any = {};
  vendorBalanceSummaryReport: any = {};
  agingInvoiceReport: any = {};
  agingVendorInvoiceReport: any = {};
  trialBalanceReport: any;
  accountReport: any = {};
  vatReportData: any = {};
  movementTrialBalanceReport: any = {};
  dayBookReportData: any = {};
  exportLoading: boolean = false;
  dayTypes: any = AGING_REPORT_TYPES;
  customerIdFromCustomerDetailPage: number | null = null;
  private partnerTypes = PartnerTypesEnum;
  public customerData: any[] = [];
  public vendorData: any[] = [];
  public accountsData: any[] = [];
  public projectsData: any[] = [];
  projectFilterCtrl = new FormControl('');

  filteredProjects: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

  private destroy$ = new Subject<void>();
  canExportReports$ = this.permissionsService.hasPermission(
      ModuleIds.Reports,
      'Export'
    );

  constructor(
    private reportService: ReportService,
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private toastr: ToastrService,
    private fileExportService: FileExportService,
    private invoiceService: InvoiceService,
    private router: Router,
    private accountService: ChartOfAccountsService,
    private customerService: CustomerService,
    private vendorService: VendorService,
    private permissionsService: PermissionService
  ) {}

  ngOnInit(): void {
    this.customerIdFromCustomerDetailPage = Number(
      history.state?.['customerId'] ??
        this.router.getCurrentNavigation()?.extras.state?.['customerId'] ??
        null
    );
    this.filteredProjects.next(this.projectsData.slice());

    // filter as user types
    this.projectFilterCtrl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((val) => this.filterProjects(val ?? ''));

    const today = new Date();
    const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const formattedStartOfMonth = this.datePipe.transform(
      startOfMonth,
      'yyyy-MM-dd'
    );
    const formattedDate = today.toISOString().split('T')[0];

    console.log('customer data:', this.customerData);
    console.log('vendor data:', this.vendorData);

    // Get the end of the current month
    const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    const formattedEndOfMonth = this.datePipe.transform(
      endOfMonth,
      'yyyy-MM-dd'
    );

    this.startDate = formattedStartOfMonth;
    this.endDate = formattedEndOfMonth;
    this.chooseDate = formattedDate;

    this.dateRangeForm = this.fb.group({
      startDate: [new Date(this.startDate)],
      endDate: [new Date(this.endDate)],
    });

    this.singleDateForm = this.fb.group({
      chooseDate: [new Date(this.chooseDate)],
    });

    this.daysRangeForm = new FormGroup({
      days: new FormControl(this.daysFilter),
    });

    this.accountForm = new FormGroup({
      account: new FormControl(this.selectedAccountId),
    });

    this.costForm = new FormGroup({
      project: new FormControl(this.selectedProjectId),
    });

    this.loadReport(0);
    this.fetchCustomers();
    this.fetchVendors();
    this.fetchChartOfAccounts();
  }

  filterProjects(value: string) {
    const search = (value || '').toLowerCase();
    if (!search) {
      this.filteredProjects.next(this.projectsData.slice());
      return;
    }
    this.filteredProjects.next(
      this.projectsData.filter((p) =>
        (p.projectName || '').toLowerCase().includes(search)
      )
    );
  }

  onDaysFilterChange(days: string) {
    this.daysFilter = days;
    this.fetchReport();
  }

  onAccountSelection(account: any) {
    this.selectedAccountId = account === -1 ? null : account;
    if (this.selectedTabIndex === 16) {
      this.fetchAccountLedgerReport(
        this.selectedAccountId,
        this.startDate,
        this.endDate
      );
    }
  }

  onCustomerChange(customerId: string) {
    this.selectedCustomerId = +customerId;
    this.fetchReport();
  }

  onVendorChange(vendorId: string) {
    this.selectedVendorId = +vendorId;
    this.fetchReport();
  }

  formatAmount(amount: number | string): string {
    const num = typeof amount === 'string' ? parseFloat(amount) : amount;
    if (isNaN(num)) return '0.00';
    return num.toFixed(2);
  }

  fetchReport() {
    if (
      this.selectedTabIndex === 14 &&
      this.daysFilter &&
      this.selectedCustomerId
    ) {
      this.getInvoiceAgingReport(
        this.startDate,
        this.endDate,
        this.selectedCustomerId
      );
    } else if (
      this.selectedTabIndex === 15 &&
      this.daysFilter &&
      this.selectedVendorId
    ) {
      this.fetchAgingReportVendorInvoice(
        this.startDate,
        this.endDate,
        this.selectedVendorId
      );
    }
  }

  onDateChange(event: any, type: string, selectedTab: number) {
    const formattedDate = this.datePipe.transform(event.value, 'yyyy-MM-dd');
    if (type === 'start') {
      this.startDate = formattedDate;
    } else if (type === 'end') {
      this.endDate = formattedDate;
    } else if (type === 'single') {
      this.chooseDate = formattedDate;
    }
    if (this.startDate != null && this.endDate != null) {
      this.filter = {
        dateRange: { startDate: this.startDate, endDate: this.endDate },
      };
      this.loadReport(selectedTab);
    }
    if (this.chooseDate != null) {
      this.loadReport(selectedTab);
    }
  }

  fetchCustomers() {
    this.customerService.fetchCustomers('').subscribe({
      next: (data: any) => {
        this.customerData = data;
      },
      error: (error) => {
        console.log(error?.message);
      },
    });
  }

  fetchVendors() {
    this.vendorService.fetchVendors('').subscribe({
      next: (data: any) => {
        this.vendorData = data;
      },
      error: (error) => {
        console.log(error?.message);
      },
    });
  }

  fetchChartOfAccounts() {
    this.accountService.fetchChartAccounts('').subscribe({
      next: (data: any) => {
        this.accountsData = data;
        if (this.accountsData?.length > 0) {
          this.selectedAccountId = this.accountsData[0].id;
        } else {
          this.selectedAccountId = null;
        }
      },
      error: (error) => {
        console.log(error?.message);
      },
    });
  }
  loadReport(index: number): void {
    console.log('Seleted Tab No', this.selectedTabIndex);
    switch (index) {
      case 0:
        this.getProfitLossReport(this.startDate, this.endDate);
        break;
      case 1:
        this.getCashFlowReport(this.startDate, this.endDate);
        break;
      case 2:
        this.getTrialBalanceReport(this.startDate, this.endDate);
        break;
      case 3:
        this.getBalanceSheet(this.startDate, this.endDate);
        break;
      case 4:
        this.getSalesByItemReport(this.startDate, this.endDate);
        break;
      case 5:
        this.getSalesByCustomerReport(this.startDate, this.endDate);
        break;
      case 6:
        this.getAccountTypeSummaryReport(this.startDate, this.endDate);
        break;
      case 7:
        this.getJournalReport(this.startDate, this.endDate);
        break;
      case 8:
        this.getGeneralLedger(this.startDate, this.endDate);
        break;
      case 9:
        this.getCustomerBalanceSummaryReport(this.startDate, this.endDate);
        break;
      case 10:
        this.getPaymentReceivedReport();
        break;
      case 11:
        this.getPaymentMadeReport();
        break;
      case 12:
        this.getVendorBalanceSummary(this.startDate, this.endDate);
        break;
      case 13:
        this.getPettyCash();
        break;
      case 14:
        this.getInvoiceAgingReport(
          this.startDate,
          this.endDate,
          this.selectedCustomerId
        );
        break;
      case 15:
        this.fetchAgingReportVendorInvoice(
          this.startDate,
          this.endDate,
          this.selectedVendorId
        );
        break;
      case 16:
        this.fetchAccountLedgerReport(
          this.selectedAccountId,
          this.startDate,
          this.endDate
        );
        break;
      case 17:
        this.getVatReport(this.startDate, this.endDate);
        break;
      case 18:
        this.getDayBookReport(this.chooseDate);
        break;
      case 19:
        this.openBankReconciliation();
        break;
      case 20:
        this.openExpenseReport();
        break;
      case 21:
        this.getMovementTrialBalanceReport(this.startDate, this.endDate);
        break;
      default:
        break;
    }
  }

  onTabChange(event: MatTabChangeEvent) {
    // this.loadReport(event.index); // Load data for the selected report
    this.loading = true; // Start loading

    // Simulate data fetching
    setTimeout(() => {
      this.loadReport(event.index);
    }, 1000);
  }

  exportReports() {
    // this.exportLoading = true;
    let exportObservable;
    console.log('case---', `${this.exportFormat}-${this.selectedTabIndex}`);
    switch (`${this.exportFormat}-${this.selectedTabIndex}`) {
      // case 'pdf':
      //   exportObservable =
      //     this.reportService.exportEmployeesToPDF(selectedFields);
      //   break;
      // case 'xls':
      //   exportObservable =
      //     this.reportService.exportEmployeesToXLSX(selectedFields);
      //   break;
      case 'csv-0':
        exportObservable = this.reportService.exportProfitLossToCSV(
          this.startDate,
          this.endDate
        );
        break;
      case 'csv-1':
        exportObservable = this.reportService.exportCashFlowToCSV(
          this.startDate,
          this.endDate
        );
        break;
      case 'csv-3':
        exportObservable = this.reportService.exportBalanceSheetToCSV(
          this.startDate,
          this.endDate
        );
        break;
      case 'csv-4':
        exportObservable = this.reportService.exportSalesByItemToCSV(
          this.startDate,
          this.endDate
        );
        break;
      case 'csv-5':
        exportObservable = this.reportService.exportSalesByCustomerToCSV(
          this.startDate,
          this.endDate
        );
        break;
      case 'csv-6':
        exportObservable = this.reportService.exportAccountTypesSummaryToCSV(
          this.startDate,
          this.endDate
        );
        break;
      case 'csv-7':
        exportObservable = this.reportService.exportJournalsReportToCSV(
          this.startDate,
          this.endDate
        );
        break;
      case 'csv-8':
        exportObservable = this.reportService.exportJournalsLedgerToCSV(
          this.startDate,
          this.endDate
        );
        break;
      case 'csv-9':
        exportObservable = this.reportService.exportCustomerBalanceSummaryToCSV(
          this.startDate,
          this.endDate
        );
        break;
      case 'csv-10':
        exportObservable = this.reportService.exportPaymentReceivedToCSV(
          this.startDate,
          this.endDate
        );
        break;
      case 'csv-11':
        exportObservable = this.reportService.exportPaymentMadeToCSV(
          this.startDate,
          this.endDate,
          []
        );
        break;
      case 'csv-12':
        exportObservable = this.reportService.exportVendorBalanceSummary(
          this.startDate,
          this.endDate
        );
        break;
      case 'csv-13':
        exportObservable = this.reportService.exportPettyCashSummary(
          this.startDate,
          this.endDate
        );
        break;
      case 'csv-14':
        exportObservable = this.reportService.exportInvoiceAgingReport(
          this.daysFilter,
          this.selectedCustomerId
        );
        break;
      case 'csv-15':
        exportObservable = this.reportService.exportBillAgingReport(
          this.daysFilter,
          this.selectedVendorId
        );
        break;
      case 'csv-16':
        exportObservable = this.reportService.exportAccountsReport(
          this.selectedAccountId,
          this.startDate,
          this.endDate
        );
        break;
      default:
        this.toastr.error('Invalid export format selected.');
        return;
    }
    // Call the export service method
    exportObservable.subscribe({
      next: (response: Blob) => {
        this.getFile(response, this.exportFormat);
        // this.exportForm.reset();
      },
      error: (error) => {
        this.toastr.error('Failed to export report. Please try again.');
      },
    });
  }

  async getFile(response: any, format: string) {
    try {
      const file = await this.fileExportService.getFileUrlPost(
        response,
        format
      );
    } catch (error) {
      console.error('Error exporting file', error);
    }
  }

  //fetch profit & loss report data
  private getProfitLossReport(startDate: string, endDate: string) {
    this.reportService.fetchProfitLossReport(startDate, endDate).subscribe({
      next: (response) => {
        this.loading = false;
        this.profitLossData = response;
        console.log('ProfitLossData:', this.profitLossData);
      },
      error: (error) => {
        this.loading = false;
        console.log('Error fetching profit loss data:', error);
      },
    });
  }

  //fetch cash flow statement report
  private getCashFlowReport(startDate: string, endDate: string) {
    this.reportService.fetchCashFlowReport(startDate, endDate).subscribe({
      next: (response) => {
        this.loading = false;
        this.cashFlowReport = response;
        console.log('CashFlowReportData:', this.cashFlowReport);
      },
      error: (error) => {
        this.loading = false;
        console.log('Error fetching Cash flow statement data:', error);
      },
    });
  }

  //fetch balance sheet report
  private getBalanceSheet(startDate: string, endDate: string) {
    this.reportService.fetchBalanceSheet(startDate, endDate).subscribe({
      next: (response) => {
        this.loading = false;
        this.balanceSheetReport = response;
      },
      error: (error) => {
        this.loading = false;
        console.log('Error fetching balance sheet data:', error);
      },
    });
  }

  //fetch sales by item report
  private getSalesByItemReport(startDate: string, endDate: string) {
    this.reportService.fetchSalesByItem(startDate, endDate).subscribe({
      next: (response) => {
        this.loading = false;
        this.salesByItemReport = response;
        console.log('Sales by Item Report:', this.salesByItemReport);
      },
      error: (error) => {
        this.loading = false;
        console.log('Error fetching sales by Item report:', error);
      },
    });
  }

  //fetch sales by customer report
  private getSalesByCustomerReport(startDate: string, endDate: string) {
    this.reportService.fetchsalesByCustomer(startDate, endDate).subscribe({
      next: (response) => {
        this.loading = false;
        this.salesByCustomReport = response;
        console.log('Sales by Custom Report:', this.salesByCustomReport);
      },
      error: (error) => {
        this.loading = false;
        console.log('Error fetching sales by Custom report:', error);
      },
    });
  }

  //fetch account type summary report
  private getAccountTypeSummaryReport(startDate: string, endDate: string) {
    this.reportService
      .fetchAccountTypeSummaryReport(startDate, endDate)
      .subscribe({
        next: (response) => {
          this.loading = false;
          this.accountTypeSummaryReport = response;
          console.log(
            'Account Type Summary Report:',
            this.accountTypeSummaryReport
          );
        },
        error: (error) => {
          this.loading = false;
          console.log('Error fetching account type summary report:', error);
        },
      });
  }

  //fetch journal report
  private getJournalReport(startDate: string, endDate: string) {
    this.reportService.fetchJournalReport(startDate, endDate).subscribe({
      next: (response) => {
        this.loading = false;
        this.journalReport = response;
        console.log('journal Report:', this.journalReport);
      },
      error: (error) => {
        this.loading = false;
        console.log('Error fetching journal report:', error);
      },
    });
  }

  //fetch general ledger report
  private getGeneralLedger(startDate: string, endDate: string) {
    this.reportService.generalLedgerReport(startDate, endDate).subscribe({
      next: (response) => {
        this.loading = false;
        this.generalLedgerReport = response;
        console.log('general ledger Report:', this.generalLedgerReport);
      },
      error: (error) => {
        this.loading = false;
        console.log('Error fetching general ledger report:', error);
      },
    });
  }

  //fetch customer balance report
  private getCustomerBalanceSummaryReport(startDate: string, endDate: string) {
    const data = {
      partnerType: 'Customer',
      ...(startDate && { startDate: startDate }),
      ...(endDate && { endDate: endDate }),
    };
    this.reportService.fetchBalanceSummary(data).subscribe({
      next: (response) => {
        this.loading = false;
        this.customerBalanceSummaryReport = response;
        console.log('ReportCustomer', this.customerBalanceSummaryReport);
      },
      error: (error) => {
        this.loading = false;
        console.log('Error fetching customer balance summary report:', error);
      },
    });
  }

  //fetch payment received report data
  private getPaymentReceivedReport() {
    this.loading = true;
    this.router.navigate(['/payment-received']);
  }

  //fetch payment made report
  private getPaymentMadeReport() {
    this.loading = true;
    this.router.navigate(['/payments-made']);
  }

  //fetch customer balance report
  private getVendorBalanceSummary(startDate: string, endDate: string) {
    const data = {
      partnerType: 'Vendor',
      ...(startDate && { startDate: startDate }),
      ...(endDate && { endDate: endDate }),
    };
    this.reportService.fetchBalanceSummary(data).subscribe({
      next: (response) => {
        this.loading = false;
        this.vendorBalanceSummaryReport = response;
        console.log(
          'this.vendorBalanceSummaryReport',
          this.vendorBalanceSummaryReport
        );
      },
      error: (error) => {
        this.loading = false;
        console.log('Error fetching vendor balance summary report:', error);
      },
    });
  }

  //fetch trial balance report
  private getTrialBalanceReport(startDate: string, endDate: string) {
    this.reportService.trialBalanceReport(startDate, endDate).subscribe({
      next: (response) => {
        this.loading = false;
        this.trialBalanceReport = response;
      },
      error: (error) => {
        this.loading = false;
        console.log('Error fetching trial balance report:', error);
      },
    });
  }

  // fetch invoice aging report
  private getInvoiceAgingReport(
    startDate: string,
    endDate: string,
    selectedCustomerId: any
  ) {
    const branchId = localStorage.getItem('selectedBranchId');
    const filters = {
      branch: Number(branchId),
      startDate: startDate,
      endDate: endDate,
      ...(selectedCustomerId != null && {
        customerId: Number(selectedCustomerId),
      }),
    };
    this.reportService.fetchAgingReportInvoice(filters).subscribe({
      next: (response) => {
        this.loading = false;
        this.agingInvoiceReport = response;
        console.log('aging invoice report:', this.agingInvoiceReport);
      },
      error: (error) => {
        this.loading = false;
        console.log('Error fetching trial balance report:', error);
      },
    });
  }

  //fetch vendor invoice aging report
  private fetchAgingReportVendorInvoice(
    startDate: string,
    endDate: string,
    vendorId: number
  ) {
    const branchId = localStorage.getItem('selectedBranchId');
    const filters = {
      branch: Number(branchId),
      startDate: startDate,
      endDate: endDate,
      ...(vendorId != null && { customerId: Number(vendorId) }),
    };
    this.reportService.fetchAgingReportVendorInvoice(filters).subscribe({
      next: (response) => {
        this.loading = false;
        this.agingVendorInvoiceReport = response;

        console.log(
          'aging Vendor invoice report:',
          this.agingVendorInvoiceReport
        );
      },
      error: (error) => {
        this.loading = false;
        console.log('Error fetching trial balance report:', error);
      },
    });
  }

  // fetch account report
  private fetchAccountLedgerReport(
    accountId: number,
    startDate: string,
    endDate: string
  ) {
    this.reportService
      .generalLedgerReport(startDate, endDate, accountId)
      .subscribe({
        next: (response) => {
          this.loading = false;
          this.accountReport = response;
          console.log('account report:', this.accountReport);
        },
        error: (error) => {
          this.loading = false;
          console.log('Error fetching account report:', error);
        },
      });
  }

  // fetch petty cash report
  private getPettyCash() {
    this.loading = true;
    this.router.navigate(['/petty-cash']);
  }

  private getVatReport(startDate: string, endDate: string) {
    this.reportService.vatReport(startDate, endDate).subscribe({
      next: (response: any) => {
        this.loading = false;
        this.vatReportData = response;
        console.log('vat report:', this.vatReportData);
      },
      error: (error: any) => {
        this.loading = false;
        console.log('Error fetching vat report:', error);
      },
    });
  }

  private getDayBookReport(date: string) {
    this.reportService.fetchDayBookReport(date).subscribe({
      next: (response: any) => {
        this.loading = false;
        this.dayBookReportData = response;
        console.log('day report:', this.dayBookReportData);
      },
      error: (error: any) => {
        this.loading = false;
        console.log('Error fetching day book report:', error);
      },
    });
  }

  private getMovementTrialBalanceReport(startDate: string, endDate: string) {
    this.reportService
      .fetchMovementTrialBalanceReport(startDate, endDate)
      .subscribe({
        next: (response: any) => {
          this.loading = false;
          this.movementTrialBalanceReport = response;
          console.log('vat report:', this.movementTrialBalanceReport);
        },
        error: (error: any) => {
          this.loading = false;
          console.log('Error fetching moment trial balance report:', error);
        },
      });
  }

  private openBankReconciliation() {
    this.loading = true;
    this.router.navigate(['/banking']);
  }

  private openExpenseReport() {
    this.loading = true;
    this.router.navigate(['/expenses']);
  }

  setTab(index: number) {
    this.selectedTabIndex = index;
  }

  toggleExport(event: MouseEvent) {
    event.stopPropagation();
    this.isExportOpen = !this.isExportOpen;
  }
}
